<template>
  <v-dialog aria-labelledby="modalatestados-titulo" v-model="modal" width="1800" @click:outside="fechaModal()" @keydown.esc="fechaModal()">
    <v-card>
      <v-card-title>
        <h3 id="modalatestados-titulo" v-if="atestado.id == null">Adicionar Atestado</h3>
        <h3 id="modalatestados-titulo" v-else>Atestado {{ atestado.dataAtestado }}</h3>
        <v-btn icon class="btn-fechar-modal" aria-label="Fechar" @click="fechaModal()"><v-icon>fa-times</v-icon></v-btn>
      </v-card-title>

      <v-card-text v-if="atestado.id != null">
        <v-container :class="$vuetify.breakpoint.lgAndUp ? 'px-8' : ''">
          <!-- Dados do Atestado -->
          <v-row class="titulo-atestado">
            <v-col>
              <h4>
                <v-icon>fas fa-caret-right</v-icon>
                Dados do Atestado
              </h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <div class="dados-atestado">
                Nome do médico
                <div class="fonte-azul">{{ atestado.nomeMedico }}</div>
              </div>
            </v-col>
            <v-col cols="6" md="4">
              <div class="dados-atestado">
                CRM
                <div class="fonte-azul">{{ atestado.crm }}</div>
              </div>
            </v-col>
            <v-col cols="6" md="4">
              <div class="dados-atestado">
                CID
                <div class="fonte-azul">{{ cid(atestado.cid) }}</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="4">
              <div class="dados-atestado">
                Quantidade de dias:
                <div class="fonte-azul">{{ atestado.qtdDias }}</div>
              </div>
            </v-col>
            <v-col cols="6" md="4">
              <div class="dados-atestado">
                Data do atestado:
                <div class="fonte-azul">{{ atestado.dataAtestado }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="dados-atestado">
                Comentário
                <div class="fonte-azul">{{ atestado.comentarios }}</div>
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-5" />

          <!-- Estado do Atestado -->
          <v-row class="titulo-atestado">
            <v-col>
              <h4>
                <v-icon>fas fa-caret-right</v-icon>
                Estado do Atestado
              </h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <div class="dados-atestado">
                Status:
                <div class="fonte-azul">{{ atestado.status.descricao }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="dados-atestado">
                Data de Atualização:
                <div class="fonte-azul">
                  {{ dataAtualizacao(atestado.dataAtualizacao) }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="dados-atestado">
                Gestor Ciente:
                <div class="fonte-azul">
                  {{ gestorCliente(atestado.gestorCiente) }}
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="atestado.status.value === enumStatus.NAO_ACEITO && atestado.observacao">
            <v-col cols="12" md="4">
              <div class="dados-atestado">
                Motivo da recusa:
                <div class="fonte-azul">{{ atestado.observacao }}</div>
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-5" />

          <!-- Documentos Anexados -->
          <v-row class="titulo-atestado">
            <v-col>
              <h4>
                <v-icon>fas fa-caret-right</v-icon>
                Documentos Anexados
              </h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                :headers="headers"
                :items="documentos"
                :items-per-page="5"
                :hide-default-footer="true"
                :no-data-text="tabelaVazia()"
              >
                <template v-slot:item.acao="{ item }">
                  <div class="acoes-tabela">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="btn-acao-tabela"
                          aria-label="Baixar"
                          v-bind="attrs"
                          v-on="on"
                          @click="visualizarDocumento(item.id)"
                        >
                          <v-icon class="icone-acao">fa-solid fa-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Baixar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-divider class="mt-8" />
        </v-container>
      </v-card-text>
      <v-card-text v-else>
        <v-container :class="$vuetify.breakpoint.lgAndUp ? 'px-8' : ''">
          <v-form ref="formContrato">
            <!-- Opções Formulário -->
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  v-erro-acessivel
                  :rules="rules.nomeMedico"
                  required
                  v-model="modeloAtestado.nomeMedico"
                  label="Nome do Médico:"
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <date-picker
                  label="Data do Atestado"
                  v-model="filtroDataAtestado"
                  :allowed-dates="allowedDates"
                  :validacao="true"
                  descricao="aviso-liberar-anexo"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="3">
                <v-text-field
                  v-erro-acessivel
                  :rules="rules.crm"
                  v-model="modeloAtestado.crm"
                  label="CRM:"
                  type="number"
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="3">
                <select-acessivel
                  v-erro-acessivel
                  :rules="rules.obrigatorio"
                  v-model="modeloAtestado.uf"
                  label="UF do CRM:"
                  outlined
                  dense
                  :items="ufs"
                  hide-details="auto"
                ></select-acessivel>
              </v-col>
              <v-col cols="6" md="3">
                <v-text-field
                  v-erro-acessivel
                  :rules="rules.campoObrigatorio"
                  v-model="modeloAtestado.qtdDias"
                  type="number"
                  label="Quantidade de Dias:"
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="3">
                <v-text-field
                  v-erro-acessivel
                  :rules="rules.cid"
                  v-model="modeloAtestado.cid"
                  label="CID (opcional):"
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Comentário (opcional):"
                  v-model="modeloAtestado.comentario"
                  outlined
                  dense
                  hide-details
                ></v-textarea>
              </v-col>
            </v-row>
            <!-- Aviso -->
            <v-row>
              <v-col>
                <Aviso
                  id="aviso-liberar-anexo"
                  message="Preencha uma data do atestado válida para liberar o anexo de documentos."
                  bg_hex="#D9D9D9"
                />
                <p class="sr-only" aria-live="polite">{{ anuncioAnexo }}</p>
              </v-col>
            </v-row>
            <!-- Anexos -->
            <div aria-live="polite" class="sr-only">
              {{
                filtroDataAtestado
                  ? 'Campos de anexo liberados: Anexar Atestado e Homologação.'
                  : ''
              }}
            </div>
            <v-row v-if="filtroDataAtestado">
              <v-col cols="12" md="6">
                <v-file-input
                  v-erro-acessivel
                  :rules="rules.atestadoObrigatorioPdf"
                  v-model="modeloAtestado.atestado"
                  outlined
                  dense
                  placeholder=" Escolha o anexo..."
                  accept="application/pdf"
                  hide-details="auto"
                  :prepend-icon="null"
                  :clearable="false"
                  aria-describedby="regra-anexo-atestado"
                  @change="anunciarAnexo('Anexar Atestado', $event)"
                >
                  <template slot="label">
                    <span>Anexar Atestado</span>
                  </template>
                  <template slot="append">
                    <v-btn
                      v-if="modeloAtestado.atestado"
                      icon
                      small
                      aria-label="Remover anexo do atestado"
                      @click.stop="removerAnexo('atestado', 'Anexar Atestado')"
                    >
                      <v-icon>fa-solid fa-xmark</v-icon>
                    </v-btn>
                    <v-icon v-else>fa-solid fa-paperclip</v-icon>
                  </template>
                </v-file-input>
                <p id="regra-anexo-atestado" class="mensagem-alerta">Permitido somente arquivos PDF</p>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                  v-erro-acessivel
                  :rules="rules.arquivoPdf"
                  color="#278b97"
                  v-model="modeloAtestado.homologacao"
                  outlined
                  dense
                  placeholder="Escolha o anexo..."
                  accept="application/pdf"
                  hide-details="auto"
                  :prepend-icon="null"
                  :clearable="false"
                  aria-describedby="regra-anexo-homologacao"
                  @change="anunciarAnexo('Homologação', $event)"
                >
                  <template slot="label">
                    <span>Homologação</span>
                  </template>
                  <template slot="append">
                    <v-btn
                      v-if="modeloAtestado.homologacao"
                      icon
                      small
                      aria-label="Remover anexo da homologação"
                      @click.stop="removerAnexo('homologacao', 'Homologação')"
                    >
                      <v-icon>fa-solid fa-xmark</v-icon>
                    </v-btn>
                    <v-icon v-else>fa-solid fa-paperclip</v-icon>
                  </template>
                </v-file-input>
                <p id="regra-anexo-homologacao" class="mensagem-alerta">
                  <v-icon>fa-solid fa-triangle-exclamation</v-icon>
                  Homologação é obrigatória para todos. Saiba mais em
                  <a
                    href="https://nossahepta.com.br/IntranetHepta/#/detalhe-academia?id=503&pesquisa=false&artigo=true"
                    target="_blank"
                  >
                    Atestados Médicos
                  </a>
                </p>
              </v-col>
            </v-row>
            <v-divider insert class="mt-5" />
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions class="botoes-modal">
        <v-row v-if="atestado.id != null">
          <v-col cols="12" md="4">
            <v-btn @click="fechaModal()" class="botao-cancelar w-100">Sair</v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" md="4">
            <v-btn @click="fechaModal()" class="botao-cancelar w-100">
              <v-icon class="mr-2">fa-solid fa-xmark</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="12" md="4">
            <v-btn @click="salvarAtestado()" class="botao-principal w-100">
              <v-icon class="mr-2">fa-solid fa-arrow-up-from-bracket</v-icon>
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/services/Api.js";
import Aviso from "@/components/Aviso.vue";
import DatePicker from "@/components/DatePicker.vue";
import SelectAcessivel from "@/components/SelectAcessivel";
import { focarPrimeiroErro } from "@/directives/erro-acessivel";

export default {
  name: "modal-atestados",
  components: { Aviso, DatePicker, SelectAcessivel },
  props: {
    atestado: {},
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    rules: {
      nomeMedico: [
        v => v.length >= 5 || "Caracteres insuficientes!",
        v => !!v || "Campo obrigatório",
      ],
      crm: [v => v.length >= 4 || "Caracteres insuficientes!", v => !!v || "Campo obrigatório"],
      cid: [v => !v || v.length >= 2 || "Caracteres insuficientes!"],
      campoObrigatorio: [v => !!v || "Campo obrigatório"],
      obrigatorio: [value => !!value || "Campo obrigatório"],
      arquivoPdf: [
        v => !v || v.type === 'application/pdf' || 'O arquivo deve ser um PDF!'
      ],
      atestadoObrigatorioPdf: [
        v => !!v || "Campo obrigatório",
        v => !v || v.type === 'application/pdf' || 'O arquivo deve ser um PDF!'
      ],
    },
    modal: false,
    download: false,
    arquivoConteudo: null,
    documentos: [],
    arquivo: {},
    headers: [
      { text: "Nome do arquivo", value: "nomeTitulo" },
      { text: "Documento", value: "codTipoDocumento.nomeDominio" },
      { text: "Ação", value: "acao", align: "center", sortable: false },
    ],
    ufs: [],
    filtroDataAtestado: null,
    anuncioAnexo: "",
    modeloAtestado: {
      nomeMedico: "",
      crm: "",
      uf: null,
      qtdDias: 0,
      cid: "",
      dataAtestado: null,
      atestado: null,
      homologacao: null,
      comentario: null,
      bkpAtestado: null,
    },
    /** Dominio */
    dominio: {
      atestado: 923,
      homologacao: 924,
      tipoPdf: 713,
      tipoPng: 715,
      tipoJpg: 714,
    },
    enumStatus: {
      ANALISE: 0,
      PENDENTE: 1,
      ACEITO: 2,
      NAO_ACEITO: 3,
    },
    feriadosCache: [],
  }),
  watch: {
    filtroDataAtestado(data) {
      this.modeloAtestado.dataAtestado = this.formatDate(data);
    },
    value(e) {
      this.modal = e;
      if (this.atestado.id != null) {
        this.buscarDocumentosAtestado();
      }
    },
  },
  methods: {
    fechaModal: function () {
      this.$emit("fecha-modal");
      this.limparVariaveis();
    },
    limparVariaveis() {
      this.modeloAtestado = {
        nomeMedico: "",
        crm: "",
        uf: null,
        qtdDias: 0,
        cid: "",
        dataAtestado: null,
        atestado: null,
        homologacao: null,
        comentario: null,
        bkpAtestado: null,
      };
      this.filtroDataAtestado = null;
    },
    anunciar(mensagem) {
      this.anuncioAnexo = "";
      this.$nextTick(() => (this.anuncioAnexo = mensagem));
    },
    anunciarAnexo(campo, arquivo) {
      this.anunciar(arquivo ? `Arquivo ${arquivo.name} anexado em ${campo}.` : `Anexo removido de ${campo}.`);
    },
    removerAnexo(chave, campo) {
      this.modeloAtestado[chave] = null;
      this.anunciarAnexo(campo, null);
    },
    buscarDocumentosAtestado() {
      const vm = this;
      api
        .get(`atestados/documento/` + vm.atestado.id)
        .then(res => {
          vm.documentos = res.data;
        })
        .catch(e => {
          console.error(e.response.data);
        });
    },
    visualizarDocumento(idDocumento) {
      const link = document.createElement("a");
      link.href = process.env.VUE_APP_URL + `atestados/documento/visualizar/` + idDocumento;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
    },
    formatDate(e) {
      if (!e) return null;
      const [year, month, day] = e.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateSQL(e) {
      if (!e) return null;
      const [day, month, year] = e.split("/");
      return `${year}-${month}-${day}`;
    },
    salvarAtestado() {
      const vm = this;

      if (vm.$refs.formContrato.validate()) {
        let atestado = null;
        let homologacao = null;

        if (vm.modeloAtestado.atestado) {
          atestado = vm.montarFormData(vm.dominio.atestado, vm.modeloAtestado.atestado);
        }
        if (vm.modeloAtestado.homologacao) {
          homologacao = vm.montarFormData(vm.dominio.homologacao, vm.modeloAtestado.homologacao);
        }

        //emit pro Atestado.vue salvar o atestado e os documentos do atestado e homologação!
        vm.$emit("salvar", vm.montarAtestado(), atestado, homologacao);
        vm.fechaModal();
      } else {
        focarPrimeiroErro(vm.$refs.formContrato);
      }
    },
    montarAtestado() {
      const vm = this;
      const obj = {
        nomeMedico: vm.modeloAtestado.nomeMedico,
        dataAtestado: vm.formatDateSQL(vm.modeloAtestado.dataAtestado),
        qtdDias: vm.modeloAtestado.qtdDias,
        crm: vm.modeloAtestado.crm + "/" + vm.modeloAtestado.uf,
        cid: vm.modeloAtestado.cid ? vm.modeloAtestado.cid : null,
        comentarios: vm.modeloAtestado.comentario ? vm.modeloAtestado.comentario : null,
        documentos: [],
      };
      return obj;
    },
    montarFormData(dominio, vModel) {
      const vm = this;
      let anexoFormData = new FormData();
      anexoFormData.append("tipoDocumento", dominio);
      anexoFormData.append("nomeTitulo", vModel.name);
      anexoFormData.append("binDocumento", vModel);
      anexoFormData.append("formatoDocumento", vm.formatoDocumento(vModel.type));
      return anexoFormData;
    },
    gestorCliente(e) {
      if (e) {
        return "Sim";
      } else {
        return "Não";
      }
    },
    formatoDocumento(vModelType) {
      const vm = this;
      switch (vModelType) {
        case "application/pdf":
          return vm.dominio.tipoPdf;
          break;
        case "image/jpeg":
          return vm.dominio.tipoJpg;
          break;
        case "image/png":
          return vm.dominio.tipoPng;
          break;
      }
    },
    dataAtualizacao(e) {
      if (e) {
        return e;
      } else {
        return "Sem data de atualização!";
      }
    },
    cid(e) {
      if (e) {
        return e;
      } else {
        return "Não informado";
      }
    },
    tabelaVazia() {
      return "Nenhum documento encontrado!";
    },
    buscarUfs() {
      const vm = this;
      api.get("v2/dominio/uf").then(response => {
        response.data.forEach(e => {
          vm.ufs.push(e.nomeDominio);
        });
      });
    },
    contarDiasUteis(dataInicio, dataFim) {
      let count = 0;
      let dataAtual = new Date(dataInicio);

      while (dataAtual <= dataFim) {
        // Ignorar fins de semana (0 = domingo, 6 = sábado)
        if (dataAtual.getDay() !== 0 && dataAtual.getDay() !== 6) count++;

        dataAtual.setDate(dataAtual.getDate() + 1);
      }

      return count;
    },
    getFeriados() {
      const hoje = new Date();
      const dataInicio = new Date(hoje);
      dataInicio.setDate(dataInicio.getDate() - 7);

      const formatDate = date => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      const vm = this;
      api
        .get(`atestados/feriado`, {
          params: {
            inicio: formatDate(dataInicio),
            fim: formatDate(hoje),
          },
        })
        .then(res => {
          vm.feriadosCache = res.data;
        })
        .catch(e => {
          console.error(e.response.data);
        });
    },
    dataValida48HrsUteis(dataString) {
      if (!dataString) return false;

      const dataSelecionada = new Date(dataString);
      const hoje = new Date();

      hoje.setHours(0, 0, 0, 0);
      dataSelecionada.setHours(0, 0, 0, 0);

      if (dataSelecionada > hoje) return true;

      const feriadosDates = this.feriadosCache
        .filter(item => item.feriado)
        .map(item => {
          const [year, month, day] = item.data.split("/");
          return new Date(`${year}-${month}-${day}`);
        });

      // verifica se uma data esta na lista dos feriados do periodo

      const isFeriado = data => {
        return feriadosDates.some(
          feriado =>
            data.getDate() === feriado.getDate() &&
            data.getMonth() === feriado.getMonth() &&
            data.getFullYear() === feriado.getFullYear()
        );
      };

      const isDiaUtil = data => {
        const diaSemana = data.getDay();
        return diaSemana !== 0 && diaSemana !== 6 && !isFeriado(data);
      };

      // contando dias uteis a partir de hoje retrocedendo
      let diasUteis = 0;
      let dataAtual = new Date(hoje);

      // se hoje for dia util, ja contamos
      if (isDiaUtil(dataAtual)) diasUteis++;

      // retrocedemos ate encontrar 3 dias uteis (hoje + 2 dias anteriores)
      while (diasUteis <= 3) {
        dataAtual.setDate(dataAtual.getDate() - 1);
        if (isDiaUtil(dataAtual)) {
          diasUteis++;
        }
      }

      dataAtual.setHours(0, 0, 0, 0);

      return dataSelecionada >= dataAtual;
    },

    buscarFeriadosDoPeriodo(inicio, fim) {
      let res = api.get("atestados/feriado", {
        params: {
          inicio,
          fim,
        },
      });

      return res.data;
    },
  },
  async mounted() {
    await this.buscarUfs();
    this.getFeriados();
  },
  computed: {
    allowedDates() {
      return date => this.dataValida48HrsUteis(date);
    },
  },
};
</script>

<style scoped>
.titulo-atestado h4 {
  display: flex;
  align-items: center;
  color: #e7b814;
  font-weight: 700;
}

.titulo-atestado h4 .v-icon {
  margin-right: 1rem;
  color: #e7b814;
}

.dados-atestado {
  border-left: 3px solid #008693;
  padding-left: 0.75rem;
  font-size: 1rem;
  text-align: left;
  color: #5d5d5d;
}

.fonte-azul {
  color: #008693;
}

.mensagem-alerta {
  color: #5d5d5d9c !important;
  font-size: 0.75rem;
}

.mensagem-alerta .v-icon {
  color: #929292;
  font-size: 1rem;
  padding-right: 0.25rem;
}

.botoes-modal .row {
  display: flex;
  justify-content: center;
}
</style>
